import { render, staticRenderFns } from "./OutsideClickContainer.vue?vue&type=template&id=1047b48f&scoped=true&"
import script from "./OutsideClickContainer.vue?vue&type=script&lang=js&"
export * from "./OutsideClickContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047b48f",
  null
  
)

export default component.exports